export default "<p class=\"text-center mb0\">\n    Got It\n</p>"